<template>

  <div>
    <div
      class="card"
      v-if="selectedJob">
      <div class="card-body">
        
        <div class="form-group">
          <label for="exampleFormControlInput1">{{ $t('Show') }}</label>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="params.evaluations">
            <label class="form-check-label">
              {{ $t('Evaluations') }}
            </label>
          </div>
        </div>

        <div
          class="btn-group"
          role="group"
          :class="{'box-loading': loading}">
          <button
            type="button"
            class="btn btn-primary"
            @click="exportCandidate(params, 'pdf')">{{ $t('Export to PDF') }}</button>

          <div class="btn-group" role="group">
            <button id="btnGroupDrop1" type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            </button>
            <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                class="dropdown-item"
                @click="exportCandidate(params, 'docx')">{{ $t('Export to DOCX') }}</button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div v-if="!selectedJob">
      <p class="alert alert-warning">{{ $t('To export, select a job') }}</p>
    </div>
  </div>

</template>

<script>
export default {
  name: 'CandidateExport',
  components: {
  },
  data () {
    return {
      loading: false,
      params: {}
    }
  },
  computed: {
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    candidate () {
      return this.$store.getters.getCandidate
    }
  },
  created () {
  },
  methods: {
    exportCandidate (params, format) {
      this.loading = true

      params.job_id = this.selectedJob._id
      params.format = format

      this.$store
      .dispatch('exportCandidate', {candidate_id: this.candidate._id, params: params})
      .then(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Export/CandidateExport.vue